import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteConfirmationModal from '../../HOC/DeleteConfirmationModal/DeleteConfirmationModal';

export interface IDeleteReportModal {
  active: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteReportModal: FC<IDeleteReportModal> = ({
  active,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();

  return (
    <DeleteConfirmationModal
      active={active}
      actionLabel={t('viewSurvey.reportsSetup.modals.delete.actions.confirm')}
      cancelLabel={t('viewSurvey.reportsSetup.modals.delete.actions.cancel')}
      title={t('viewSurvey.reportsSetup.modals.delete.report.title')}
      text={t('viewSurvey.reportsSetup.modals.delete.report.text')}
      description={t('viewSurvey.reportsSetup.modals.delete.report.subtext')}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default DeleteReportModal;
